export const settingsPath = "/settings";

export default settingsPath;
